import React from 'react';
import { SNS, SNSIcon, snsToString } from './SNS';
import { initializeScrolTop } from 'utils/dom';

export const ToSharePageButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className: string;
}) => {
  return (
    <>
      <div
        className={`w-5.5 h-7 font-bold rounded bg-white border border-link flex flex-row whitespace-no-wrap items-center py-2 px-2 text-sm text-link ${className ??
          ''}`}
        onClick={(): void => {
          initializeScrolTop();
          onClick();
        }}>
        <img
          src="/static/images/icon/icon-upload.svg"
          alt="アップロード"
          className="h-2.5 mr-1"
        />
        <div className="mx-auto">シェア</div>
      </div>
    </>
  );
};

export const SNSShareButton = ({
  sns,
  onClick,
  className,
  disabled,
}: {
  sns: SNS;
  onClick: () => void;
  className?: string;
  disabled: boolean;
}) => {
  return (
    <>
      <button
        onClick={onClick}
        className={`py-2 border-blue-700 border items-center gap-2 justify-center rounded-lg shadow flex flex-row ${className ??
          ''} ${disabled ? 'opacity-10 cursor-default' : ''}`}
        disabled={disabled}>
        <SNSIcon {...{ sns }} />
        <div className="text-blue-700 font-bold">
          {snsToString(sns)}でシェアする
        </div>
      </button>
    </>
  );
};

export const ToShareTwitterIconButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <div
      className={`flex flex-row ${className ?? ''}`}
      onClick={(): void => {
        initializeScrolTop();
        onClick();
      }}>
      <div className="absolute z-10 ml-auto right-2 top-8">
        <img
          className=""
          src={`/static/images/icon/icon_twitter.svg`}
          alt="アイコン"
        />
      </div>
    </div>
  );
};
